// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IClaimTransferAccountResponse } from './IClaimTransferAccountResponse';
import {
    IClaimTransferAccountResponseFromJSON,
    IClaimTransferAccountResponseFromJSONTyped,
    IClaimTransferAccountResponseToJSON,
    IClaimTransferAccountResponseToJSONTyped,
} from './IClaimTransferAccountResponse';

/**
 * 
 * @export
 * @interface IClaimTransferAccountsResponse
 */
export interface IClaimTransferAccountsResponse {
    /**
     * 
     * @type {Array<IClaimTransferAccountResponse>}
     * @memberof IClaimTransferAccountsResponse
     */
    recommended: Array<IClaimTransferAccountResponse>;
    /**
     * 
     * @type {Array<IClaimTransferAccountResponse>}
     * @memberof IClaimTransferAccountsResponse
     */
    other: Array<IClaimTransferAccountResponse>;
}

/**
 * Check if a given object implements the IClaimTransferAccountsResponse interface.
 */
export function instanceOfIClaimTransferAccountsResponse(value: object): value is IClaimTransferAccountsResponse {
    if (!('recommended' in value) || value['recommended'] === undefined) return false;
    if (!('other' in value) || value['other'] === undefined) return false;
    return true;
}

export function IClaimTransferAccountsResponseFromJSON(json: any): IClaimTransferAccountsResponse {
    return IClaimTransferAccountsResponseFromJSONTyped(json, false);
}

export function IClaimTransferAccountsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimTransferAccountsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'recommended': ((json['recommended'] as Array<any>).map(IClaimTransferAccountResponseFromJSON)),
        'other': ((json['other'] as Array<any>).map(IClaimTransferAccountResponseFromJSON)),
    };
}

export function IClaimTransferAccountsResponseToJSON(json: any): IClaimTransferAccountsResponse {
    return IClaimTransferAccountsResponseToJSONTyped(json, false);
}

export function IClaimTransferAccountsResponseToJSONTyped(value?: IClaimTransferAccountsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'recommended': ((value['recommended'] as Array<any>).map(IClaimTransferAccountResponseToJSON)),
        'other': ((value['other'] as Array<any>).map(IClaimTransferAccountResponseToJSON)),
    };
}

